import {IObjectData, IRouteDefinitionParams} from '../../../index';
import {global} from "../../../appContext";
import {template as tpl, UserWizardMutable} from "./mutable";
import PromiseRequest from "../../../req/PromiseRequest";
import {INPUT_DATE_FORMAT} from "../../../constants";
import {nsUserWizard} from "./nsUserWizard";
import {createErrorMessage} from "../../../util/misc";
import {PersonaliaModelCreate} from "./PersonaliaModelCreate";
import {CREATING_MESSAGE, REQUEST_MESSAGE} from "../../../constants/Language";
import {moment} from 'moment';
import {TOperationType} from "./index";
import Step = nsUserWizard.Step;

export const template = tpl

export class viewModel extends UserWizardMutable {

    protected readonly reqSubmit: PromiseRequest = global.getPromiseRequest("createobject")
    protected readonly operationType: TOperationType = 'create'

    constructor(params: IRouteDefinitionParams) {
        super(params)
        this.init()
    }

    protected override init(): Promise<any> {
        this.isReady(false)
        this.messageData({message: REQUEST_MESSAGE})
        this.step(null);
        this.personaliaModel = new PersonaliaModelCreate({dataset: this.dataset})
        return super.init()
            .then(() => {
                this.personaliaModel.initErrorObjects()
                const start = moment().startOf('day').format(INPUT_DATE_FORMAT)
                this.primaryPositionModel.initMeta({
                    start,
                    isNoEndDate: false,
                    isNoStartDate: false,
                })

                this.step(Step.Personalia)
                this.messageData(null)
                this.isReady(true)

                



























            })
    }

    protected onSubmit() {
        const data = this.getSubmitData();
        this.messageData({message: CREATING_MESSAGE});
        this.reqSubmit.abort();
        this.reqSubmit
            .request({
                jobject: JSON.stringify(data)
            })
            .then((data: IObjectData[]) => {
                global.cacheManager.removeCache('getruleset');
                global.cacheManager.removeCache('searchruleset');
                global.cacheManager.removeCache('searchobject');
                global.cacheManager.removeCache('getobject');
                this.dataset.original = data[0] ?? null;
                this.step(Step.Success);
                this.messageData({message: `subject is created|s:((manual user))`})
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.step(Step.Error);
                this.messageData(createErrorMessage(String(reason)));
            });
    }

}
